<template>
  <section class="auth-card" data-testid="auth-card" :aria-labelledby="titleId">
    <header class="auth-card__header">
      <h1 :id="titleId" class="auth-card__title">{{ title }}</h1>
      <p v-if="description" class="auth-card__description">{{ description }}</p>
    </header>

    <div
      v-if="errorMessage"
      :id="errorId"
      ref="error"
      class="auth-card__message auth-card__message--error"
      role="alert"
      tabindex="-1"
      data-testid="auth-error"
    >
      <q-icon name="error_outline" aria-hidden="true" />
      <span>{{ errorMessage }}</span>
    </div>
    <div v-if="loading" class="auth-card__message auth-card__message--loading" role="status" data-testid="auth-loading">
      <q-spinner size="1.25rem" />
      <span>{{ loadingMessage || 'Выполняем запрос' }}</span>
    </div>

    <div class="auth-card__body"><slot /></div>
    <div v-if="$slots.footer" class="auth-card__footer"><slot name="footer" /></div>
  </section>
</template>

<script>
export default {
  name: 'AuthCard',
  props: {
    title: { type: String, required: true },
    description: { type: String, default: '' },
    titleId: { type: String, default: 'auth-title' },
    errorId: { type: String, default: 'auth-error' },
    errorMessage: { type: String, default: '' },
    loading: { type: Boolean, default: false },
    loadingMessage: { type: String, default: '' }
  },
  methods: {
    focusError() {
      this.$nextTick(() => {
        if (this.$refs.error) this.$refs.error.focus()
      })
    }
  }
}
</script>

<style scoped>
.auth-card { width: 100%; max-width: 28rem; padding: var(--sid-space-6); border: 1px solid var(--sid-color-line); border-radius: var(--sid-radius-large); background: var(--sid-color-surface-0); box-shadow: var(--sid-elevation-1); }
.auth-card__header { margin-bottom: var(--sid-space-5); }
.auth-card__title { margin: 0; }
.auth-card__description { margin: var(--sid-space-2) 0 0; color: var(--sid-color-text-secondary); line-height: var(--sid-line-height-body); }
.auth-card__message { display: flex; min-height: var(--sid-touch-target); align-items: center; gap: var(--sid-space-2); margin-bottom: var(--sid-space-4); padding: var(--sid-space-3); border-radius: var(--sid-radius-surface); }
.auth-card__message--error { background: var(--sid-color-danger-surface); color: var(--sid-color-danger); }
.auth-card__message--loading { background: var(--sid-color-info-surface); color: var(--sid-color-info); }
.auth-card__footer { margin-top: var(--sid-space-5); color: var(--sid-color-text-secondary); text-align: center; }
.auth-card__footer :deep(p) { margin: 0; }
.auth-card__body :deep(.auth-form) { display: flex; flex-direction: column; gap: var(--sid-space-4); }
.auth-card__body :deep(.auth-submit) { width: 100%; min-height: var(--sid-touch-target); }

@media (max-width: 599px) {
  .auth-card { max-width: none; padding: var(--sid-space-4) 0; border: 0; border-radius: 0; background: transparent; box-shadow: none; }
  .auth-card__header { margin-bottom: var(--sid-space-4); }
}
</style>
